<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import request from './utils/request'
import store from './store'
import { Notification } from 'element-ui';
export default {
  data() {
    return {
      id: '',
      websockStatus: false
    }
  },
  beforeCreate() {
    this.websockStatus = false
  },
  created() {
    if (store.state.userInfo.userId !== undefined && this.$route.name !== 'login') {
      this.addId(store.state.userInfo.userId)
    }
  },
  methods: {
    // websocket
    initWebSocket() { //初始化weosocket
      const wsuri = `wss://www.sjxsm.com/webSocket/${this.id}`;
      this.websock = new WebSocket(wsuri);
      this.websockStatus = true
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = setTimeout(() => {
        this.websocketonerror;
      }, 5000);

      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() { //连接建立之后执行send方法发送数据
      // let actions = { "test": "12345" };
      // this.websocketsend(JSON.stringify(actions));
    },
    websocketonerror() {//连接建立失败重连
      let that = this
      if (this.$route.name !== 'login') {
        that.initWebSocket();
      }

    },
    websocketonmessage(e) { //数据接收
      // console.log(e);
      let that = this
      if (e.data === '连接成功') {
        return
      } else {
        const redata = JSON.parse(e.data);
        if (redata.flag === 'UPDATE') {
          store.state.userInfo.authorization = redata.token
          sessionStorage.setItem('authorization', redata.token)
          setTimeout(() => {
            that.getMenu(redata.roleId)
          }, 1);
        } else if (redata.flag === "MODIFY" && redata.roleId === store.state.userInfo.roleId) {
          console.log(redata.flag);
          Notification({
            message: "权限已经更改，请重新登陆",
            type: 'success'
          })
          setTimeout(() => {
            this.$router.push('/')
          }, 5000);
        }


      }
    },
    websocketsend(Data) {//数据发送
      this.websock.send(Data);
    },
    websocketclose() {  //关闭
      this.initWebSocket()
    },
    // 用户id
    addId(val) {
      this.id = val
      this.initWebSocket()
    },
    // 权限列表、
    async getMenu(val) {
      const res = await request({
        method: 'GET',
        url: `admin/user/login/menu?roleId=${val}`
      })
      if (res.code === '200') {
        store.state.menu = res.data
      } else {
        this.$message.error(res.message)
      }
    }
  },
  beforeUpdate() {
    if (store.state.userInfo.userId !== undefined && this.$route.name === 'login') {
      this.websock.onclose
    }
  },
  destroyed() {
    if (this.websockStatus) {
      this.websock.onclose
    }

  }

}

</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.global-table-box {
  min-height: 600px;
  background-color: #fff;
}

.el-dialog__header {
  background-color: #54A8FD;
  padding: 10px !important;
  border-radius: 10px 10px 0 0;
}

.el-dialog {
  border-radius: 11px !important;
}
</style>
